import { render, staticRenderFns } from "./GradesProgramServes.vue?vue&type=template&id=537417bf"
import script from "./GradesProgramServes.vue?vue&type=script&lang=ts"
export * from "./GradesProgramServes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports